import { render, staticRenderFns } from "./ApprovalInstructions.vue?vue&type=template&id=1c0e21b8&scoped=true&"
import script from "./ApprovalInstructions.vue?vue&type=script&lang=js&"
export * from "./ApprovalInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e21b8",
  null
  
)

export default component.exports